import { AxiosResponse } from 'axios';

import axiosApi from 'utils/axios';
import { decamelizeKeys } from 'utils/humps';

import { getAccountId } from './auth';

export type DefaultValues = {
  data?: {
    defaultValues?: {
      data?: object;
      icon?: string;
    };
  };
};

export type GetDefaultValuesResponse = DefaultValues;

export const getDefaultValues = async (
  eventType?: string,
  pageId?: string | number | null,
  pageName?: string | null,
) => {
  const response = (await axiosApi.get(`/acc/${getAccountId()}/trip_event_default_values`, {
    params: decamelizeKeys({ eventType, pageId, pageName }),
  })) as AxiosResponse<GetDefaultValuesResponse>;

  return response.data?.data?.defaultValues;
};
